import CustomButton from 'Components/CustomButton'
import DrawerRight from 'Components/DrawerRight'
import { WithLoader } from 'Components/WithLoader'
import TicketSaleTargetDetails from 'Services/SalesManagement/Features/TicketSale/Components/TicketSaleTargetDetails'
import { useGetSingleTicketSaleTargetQuery } from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'
import { TicketSaleTargetTabType } from 'Services/SalesManagement/Features/TicketSale/types'
import { SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import EditIcon from '@mui/icons-material/Edit'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Divider, Tab } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { t } from 'ttag'

interface TicketSaleTargetDrawerProps {
  open: boolean
  handleClose: () => void
  selectedTicketSaleTargetId: string | undefined
}

export default function TicketSaleTargetDrawer({
  open,
  handleClose,
  selectedTicketSaleTargetId
}: Readonly<TicketSaleTargetDrawerProps>) {
  const navigate = useNavigate()
  const baseUrl = `${SALES_MANAGEMENT_ROOT_URL}/ticket-sales/ticket-sale-targets`
  const { data: singleTicketSaleTarget, isFetching: isSingleTicketSaleTargetFetching } =
    useGetSingleTicketSaleTargetQuery(selectedTicketSaleTargetId ?? '', {
      skip: !selectedTicketSaleTargetId
    })

  return (
    <DrawerRight
      open={open}
      onClose={handleClose}
      topBar={
        <Box>
          <CustomButton
            onClick={() => navigate(`${baseUrl}/${selectedTicketSaleTargetId}/edit`)}
            size="small"
            startIcon={<EditIcon />}
          >{t`Edit`}</CustomButton>
        </Box>
      }
    >
      <WithLoader loading={isSingleTicketSaleTargetFetching}>
        {singleTicketSaleTarget && (
          <TabContext value={TicketSaleTargetTabType.DETAILS}>
            <TabList aria-label={t`Details`}>
              <Tab label={t`Details`} value={TicketSaleTargetTabType.DETAILS} />
            </TabList>
            <Divider />
            <TabPanel sx={{ p: 0 }} value={TicketSaleTargetTabType.DETAILS}>
              <TicketSaleTargetDetails ticketSaleTarget={singleTicketSaleTarget} />
            </TabPanel>
          </TabContext>
        )}
      </WithLoader>
    </DrawerRight>
  )
}
